import React from 'react';


const Email = props => {
  return(
    <>
<svg xmlns="http://www.w3.org/2000/svg" style={{ fill: props.color, stroke:props.color}} viewBox="0 0 448 512"><path d="M21 139.038c-2.8 0-5 2.2-5 5v24.7l210.5 148.3 210.5-148.3v-24.7c0-2.8-2.2-5-5-5H21zm-5 54.3v182.6l112.3-103.5-112.3-79.1zm421 0l-112.3 79.1 112.3 103.5v-182.6zm-292.1 90.9l-114.2 105.4h391.6l-114.2-105.4-75.8 53.4c-3.5 2.5-8.1 2.5-11.6 0l-75.8-53.4z"/></svg>

</>
  )


}
export default Email;
